import React, {Component} from 'react';
import ValueTypeSelector from "../../../ValueTypeSelector";
import MaterialIcon from "../../../../../MaterialIcon";

import axios from 'axios';
import getAxiosConfig from '../../../../../../utils/axiosConfig';
import messageCodes from "../../../../../../utils/messageCodes";
import {connect} from "react-redux";
import {showToastForBackend, showToastForFrontend} from "../../../../../../actions/toastActions";

import contextPropertyFuncCalls from '../contextModifierFuncCalls';
import {ContextPropertySelect} from "../../../InputPortListUtils/components/ContextPropertySelect";
import {FunctionInput} from "../../../InputPortListUtils/components/FunctionInput";
import {DefaultValueInput} from "../../../InputPortListUtils/components/DefaultValueInput";
import {PropertySelect} from "../../../InputPortListUtils/components/PropertySelect";
import {contextPropertyDefaultOptions} from "./contextPropertyDefaultOptions";


class ContextPropertyModifierValue extends Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();

        const funcTypeOptions = this.props.funcType + "Options";

        this.state = {
            [funcTypeOptions]: this.props[funcTypeOptions] ? this.props[funcTypeOptions] : contextPropertyDefaultOptions[funcTypeOptions],
            type: this.props.type,
            value: this.props.value,
            id: this.props.id,
            funcType: this.props.funcType,

            names: this.props.names ? this.props.names : [],
            keys: this.props.keys ? this.props.keys : [],
            isRegexPattern: false
        };

        this.types = [
            {
                text: "Context Property",
                xmlType: "contextProperty"
            },
            {
                text: "Constant Value",
                xmlType: "constantValue"
            }
        ];
        this.typesParseDate = [...this.types, 
            {
                text: "Current Timestamp",
                xmlType: "currentTimestamp"
            }
        ];
        this.propertyTypes = [
            {
                text: "Item Property",
                xmlType: "itemProperty"
            },
            {
                text: "Dynamic Property",
                xmlType: "dynamicProperty"
            }
        ];

        let isOperatorValid = false;
        for (let operatorOptionIndex in contextPropertyFuncCalls) {
            if (this.state.funcType === contextPropertyFuncCalls[operatorOptionIndex].type) {
                isOperatorValid = true;
            }
        }

        if (!isOperatorValid) {
            this.state.funcType = contextPropertyFuncCalls[0].type;
        }

        this.createPropertySide = this.createPropertySide.bind(this);
        this.createRow = this.createRow.bind(this);
        this.createFuncSelect = this.createFuncSelect.bind(this);
        this.onFuncSwitch = this.onFuncSwitch.bind(this);
        this.onPropertyValueChange = this.onPropertyValueChange.bind(this);
        this.onLookupNameChange = this.onLookupNameChange.bind(this);
        this.onRegexPatternCheck = this.onRegexPatternCheck.bind(this);
    }

    componentDidMount() {
        if (this.state.type === "constantValue" && this.state.value === ""  && this.inputRef.current) {
            this.inputRef.current.focus();
        }
        const names = this.state.names;
        if (names.length === 0) {
            axios.get(this.props.properties.databaseUrl + "/lookup", getAxiosConfig())
                .then(response => {
                    this.setState({
                        names: response.data.sort()
                    });
                })
                .catch(err => {
                    if (err.response)
                        this.props.showToastForBackend(err.response.data);
                    else
                        this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                });
        }
    }

    onLookupNameChange(e) {
        const value = e.target.value || "";
        if (value.length > 0) {
            axios.get(this.props.properties.databaseUrl + "/lookup/" + value , getAxiosConfig())
                .then(response => {
                    let update = {};
                    update.lookupOptions = {
                        ...this.state.lookupOptions
                    };
                    update.lookupOptions.dataValue = '';
                    update.keys = response.data.sort();
                    this.setState({
                        ...update
                    }, () => {
                        this.props.onArgumentOptionUpdate(this.state);
                    });
                })
                .catch(err => {
                    if (err.response)
                        this.props.showToastForBackend(err.response.data);
                    else
                        this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                });
        } else {
            this.setState({
                keys: []
            });
        }
    }

    onOptionPropertyTypeChange(text, property, optionName) {
        let update = {};
        update[optionName] = {
            ...this.state[optionName]
        };

        update[optionName][property + "Type"] = this.types.find((type) => type.text === text).xmlType;
        update[optionName][property + "Value"] = '';

        this.setState({
            ...update
        }, () => {
            this.props.onArgumentOptionUpdate(this.state);
        });
    }

    onParseDateOptionPropertyTypeChange(text, property, optionName) {
        let update = {};
        update[optionName] = {
            ...this.state[optionName]
        };

        update[optionName][property + "Type"] = this.typesParseDate.find((type) => type.text === text).xmlType;
        update[optionName][property + "Value"] = '';

        this.setState({
            ...update
        }, () => {
            this.props.onArgumentOptionUpdate(this.state);
        });
    }

    onItemPropertyTypeChange(text, property, optionName) {
        let update = {};
        update[optionName] = {
            ...this.state[optionName]
        };

        update[optionName][property + "Type"] = this.propertyTypes.find((type) => type.text === text).xmlType;
        update[optionName][property + "Value"] = '';

        this.setState({
            ...update
        }, () => {
            this.props.onArgumentOptionUpdate(this.state);
        });
    }

    onRegexPatternCheck(e, property, optionName) {
        const value = e.target.checked;
        let update = {};
        update[optionName] = {...this.state[optionName]};
        update[optionName][property] = value;
        this.setState({
            ...update
        }, () => {
            this.props.onArgumentOptionUpdate(this.state);
        })
    }

    onPropertyValueChange(e, property, optionName) {
        const value = e.target.value || "";
        let update = {};
        update[optionName] = {...this.state[optionName]};
        update[optionName][property + (optionName !== "userPropertyOptions" ? "Value" : "")] = value;

        this.setState({
            ...update
        }, () => {
            this.props.onArgumentOptionUpdate(this.state);
        })
    }

    onArgumentDelete(index) {
        let funcName = {...this.state.funcName};
        funcName.funcArgs = funcName.funcArgs.filter((value, funcArgIndex) => funcArgIndex !== index);

        this.setState({
            funcName: {
                ...funcName
            }
        }, () => {
            this.props.onArgumentOptionUpdate(funcName);
        });
    }

    onFuncSwitch(e) {
        const funcType = e.target.value;

        const newOptions = {
            funcType
        };

        this.setState(newOptions, () => {
            this.props.onArgumentOptionUpdate(this.state)
        });
        
    }

    createPropertySide(property) {
        const optionName = (this.state.funcType !== undefined ? this.state.funcType : "none") + "Options";
        const propertyType = property + "Type";
        const propertyValue = property + "Value";

        if (this.state[optionName] === undefined) {
            const newState = {
                ...this.state,
                [optionName]: contextPropertyDefaultOptions[optionName]
            }
            this.setState(newState)
        }

        const selectedType = this.state[optionName] && this.state[optionName][propertyType]
            ? this.state[optionName][propertyType]
            : contextPropertyDefaultOptions[optionName][propertyType];
        const selectedValue = this.state[optionName] && this.state[optionName][propertyValue]
            ? this.state[optionName][propertyValue]
            : contextPropertyDefaultOptions[optionName][propertyValue];

        return (
            <React.Fragment>
            <div className="predicate-box left">
                <ValueTypeSelector
                    types={this.types}
                    disableArea={this.props.disableArea}
                    selectedType={selectedType}
                    onTypeSelect={(index) => this.onOptionPropertyTypeChange(index, property, optionName)}
                />

                {(() => {
                    switch (selectedType) {
                        case "contextProperty":
                            return (<ContextPropertySelect
                                value={selectedValue}
                                onChange={(e) => this.onPropertyValueChange(e, property, optionName)}
                                options={this.props.contextProperties}
                            />);
                        case "constantValue":
                            return (<input
                                type="text"
                                ref={this.inputRef}
                                value={selectedValue}
                                onChange={(e) => this.onPropertyValueChange(e, property, optionName)}
                            />);
                    }
                })()}
            </div>
            {selectedType === "contextProperty" && (
                <DefaultValueInput
                    value={this.state[optionName].defaultValue}
                    onChange={(e) => this.onPropertyValueChange(e, 'default', optionName)}
                />
            )}
            </React.Fragment>
        )
    }

    createFuncSelect() {
        return(
            <div className="operation predicate-box">
                <select value={this.state.funcType} onChange={this.onFuncSwitch} disabled={this.props.disableArea ? true : false}>
                    {contextPropertyFuncCalls.sort(
                        (a, b) => a.label > b.label ? 1 : -1
                    ).map((func, index) => (
                        <option key={index} value={func.type}>{func.label}</option>
                    ))}
                </select>
            </div>
        )
    }

    createRow() {
        const funcType = this.state.funcType;
        const funcTypeOptionsField = funcType + "Options";
        const funcTypeOptions = this.state[funcTypeOptionsField] ? this.state[funcTypeOptionsField] : contextPropertyDefaultOptions[funcTypeOptionsField];

        return (
            <div className="predicate-item-content">
                {this.createFuncSelect()}

                {!["randomInt", "currentHourTZ", "currentMinuteTZ", "currentDayOfTheWeekTZ",
                        "userProperty", "lookup", "inputCount", "parseDate", "itemPropertyToContext", "itemId"].includes(funcType)
                    && this.createPropertySide("data")}

                {funcType === "randomInt" &&
                    <>
                        <FunctionInput
                            label="Lower bound"
                            value={funcTypeOptions["lowerBoundValue"]}
                            onChange={(e) => this.onPropertyValueChange(e, "lowerBound", funcTypeOptionsField)}
                        />
                        <FunctionInput
                            label="Upper bound"
                            value={funcTypeOptions["upperBoundValue"]}
                            onChange={(e) => this.onPropertyValueChange(e, "upperBound", funcTypeOptionsField)}
                        />
                    </>
                }

                {funcType === "split" &&
                    <>
                        <FunctionInput label="separator"
                                       value={funcTypeOptions["separatorValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "separator", funcTypeOptionsField)}
                        />
                        <FunctionInput label="limit"
                                       value={funcTypeOptions["limitValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "limit", funcTypeOptionsField)}
                        />
                    </>
                }
                {funcType === "indexOf" &&
                    <>
                        <FunctionInput label="substring"
                                       value={funcTypeOptions["substringValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "substring", funcTypeOptionsField)}
                        />
                    </>
                }
                {funcType === "nElement" &&
                    <>
                        <FunctionInput label="index"
                                       value={funcTypeOptions["indexValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "index", funcTypeOptionsField)}
                        />
                    </>
                }

                {funcType === "indexOfArray" &&
                    <>
                        <FunctionInput label="value"
                                       value={funcTypeOptions["substringValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "substring", funcTypeOptionsField)}
                        />
                    </>
                }
                {funcType === "nElementArray" &&
                    <>
                        <FunctionInput label="index"
                                       value={funcTypeOptions["indexValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "index", funcTypeOptionsField)}
                        />
                    </>
                }

                {funcType === "currentHourTZ" &&
                    <FunctionInput label="Time Zone Offset"
                                   value={funcTypeOptions["timeZoneOffsetValue"]}
                                   onChange={(e) => this.onPropertyValueChange(e, "timeZoneOffset", funcTypeOptionsField)}
                    />
                }

                {funcType === "currentMinuteTZ" &&
                    <FunctionInput label="Time Zone Offset"
                                   value={funcTypeOptions["timeZoneOffsetValue"]}
                                   onChange={(e) => this.onPropertyValueChange(e, "timeZoneOffset", funcTypeOptionsField)}
                    />
                }

                {funcType === "currentDayOfTheWeekTZ" &&
                    <FunctionInput label="Time Zone Offset"
                                   value={funcTypeOptions["timeZoneOffsetValue"]}
                                   onChange={(e) => this.onPropertyValueChange(e, "timeZoneOffset", funcTypeOptionsField)}
                    />
                }

                {funcType === "userProperty" &&
                    <>
                        <FunctionInput label="Property name"
                                       value={funcTypeOptions["propertyName"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "propertyName", funcTypeOptionsField)}
                        />
                        <DefaultValueInput value={funcTypeOptions["defaultValue"]}
                                           onChange={(e) => this.onPropertyValueChange(e, "defaultValue", funcTypeOptionsField)}
                        />
                    </>
                }

                {funcType === "lookup" &&
                    <PropertySelect value={funcTypeOptions["nameValue"]}
                                    onChange={(e) => {this.onPropertyValueChange(e, "name", funcTypeOptionsField); this.onLookupNameChange(e)}}
                                    options={this.state.names}
                                    disabled={funcTypeOptions["nameValue"]}
                    />
                }

                {funcType === "lookup" &&
                    <React.Fragment>
                        <div className="predicate-box left">
                            <ValueTypeSelector
                                types={this.types}
                                disableArea={this.props.disableArea}
                                selectedType={funcTypeOptions["dataType"]}
                                onTypeSelect={(index) => this.onOptionPropertyTypeChange(index, 'data', funcTypeOptionsField)}
                            />
                            {funcTypeOptions["dataType"] === "contextProperty" && (
                                <ContextPropertySelect value={funcTypeOptions["dataValue"]}
                                                       onChange={(e) => this.onPropertyValueChange(e, 'data', funcTypeOptionsField)}
                                                       options={this.props.contextProperties}/>
                            )}

                            {funcTypeOptions["dataType"] === "constantValue" && (
                                <PropertySelect value={funcTypeOptions["dataValue"]}
                                                onChange={(e) => this.onPropertyValueChange(e, "data", funcTypeOptionsField)}
                                                options={this.state.keys}
                                                disabled={funcTypeOptions["dataValue"]}
                                />
                            )}
                        </div>

                        {funcTypeOptions["dataType"] === "contextProperty" && (
                            <DefaultValueInput
                                value={funcTypeOptions.defaultValue}
                                onChange={(e) => this.onPropertyValueChange(e, 'default', funcTypeOptionsField)}
                            />
                        )}
                    </React.Fragment>
                }

                {funcType === "parseDate" &&
                     <React.Fragment>
                         <div className="predicate-box left">
                             <ValueTypeSelector
                                 types={this.typesParseDate}
                                 disableArea={this.props.disableArea}
                                 selectedType={funcTypeOptions["dataType"]}
                                 onTypeSelect={(index) => this.onParseDateOptionPropertyTypeChange(index, "data", funcTypeOptionsField)}
                             />

                             {funcTypeOptions["dataType"] === "contextProperty" && (
                                 <ContextPropertySelect value={funcTypeOptions["dataValue"]}
                                                        onChange={(e) => this.onPropertyValueChange(e, "data", funcTypeOptionsField)}
                                                        options={this.props.contextProperties}
                                 />
                             )}

                             {funcTypeOptions["dataType"] === "constantValue" && (
                                 <input
                                     type="text"
                                     value={funcTypeOptions["dataValue"]}
                                     onChange={(e) => this.onPropertyValueChange(e, "data", funcTypeOptionsField)}
                                 />
                             )}
                         </div>

                         {funcTypeOptions["dataType"] === "contextProperty" && (
                             <DefaultValueInput value={funcTypeOptions.defaultValue}
                                                onChange={(e) => this.onPropertyValueChange(e, 'default', funcTypeOptionsField)}
                             />
                         )}
                     </React.Fragment>
                }

                {funcType === "parseDate" && funcTypeOptions["dataType"] !== "currentTimestamp" &&
                    <FunctionInput label="Input Date Format"
                                   value={funcTypeOptions["inFormatValue"]}
                                   onChange={(e) => this.onPropertyValueChange(e, "inFormat", funcTypeOptionsField)}
                    />
                }

                {funcType === "parseDate" &&
                    <>
                        <FunctionInput label="Output Date Format"
                                       value={funcTypeOptions["outFormatValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "outFormat", funcTypeOptionsField)}
                        />
                        <FunctionInput label="Time Zone Offset"
                                       value={funcTypeOptions["timeZoneOffsetValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "timeZoneOffset", funcTypeOptionsField)}
                        />
                    </>
                }

                {funcType === "regex" &&
                    <>
                        <FunctionInput label="Pattern"
                                       value={funcTypeOptions["patternValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "pattern", funcTypeOptionsField)}
                        />
                        <FunctionInput label="Insert Group"
                                       value={funcTypeOptions["insertGroupValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "insertGroup", funcTypeOptionsField)}
                        />
                    </>
                }

                {funcType === "arrayLimit" &&
                    <FunctionInput label="Limit"
                                   value={funcTypeOptions["limitValue"]}
                                   onChange={(e) => this.onPropertyValueChange(e, "limit", funcTypeOptionsField)}
                    />
                }

                {funcType === "replace" &&
                    <>
                        <FunctionInput label="Pattern"
                                       value={funcTypeOptions["patternValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "pattern", funcTypeOptionsField)}
                        />
                        <div className='input-container'>
                            <input type="checkbox"
                                   name="isRegex"
                                   className="checkbox static-text"
                                   checked={funcTypeOptions["isRegexPattern"]}
                                   onChange={(e) => this.onRegexPatternCheck(e, "isRegexPattern", funcTypeOptionsField)}/>
                            <label className='static-text' htmlFor="isRegex">
                                Regex pattern
                            </label>
                        </div>
                        <FunctionInput label="Replacement"
                                       value={funcTypeOptions["replacementValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "replacement", funcTypeOptionsField)}
                        />
                    </>
                }

                {funcType === "splitWithoutSuffixes" &&
                    <>
                        <FunctionInput label="separator"
                                       value={funcTypeOptions["separatorValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "separator", funcTypeOptionsField)}
                        />
                        <FunctionInput label="limit"
                                       value={funcTypeOptions["limitValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "limit", funcTypeOptionsField)}
                        />
                    </>
                }

                {funcType === "stringJoin" &&
                    <FunctionInput label="Separator"
                                   value={funcTypeOptions["separatorValue"]}
                                   onChange={(e) => this.onPropertyValueChange(e, "separator", funcTypeOptionsField)}
                    />
                }

                {funcType === "substring" &&
                    <>
                        <FunctionInput label="Start index"
                                       value={funcTypeOptions["startIndexValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "startIndex", funcTypeOptionsField)}
                        />
                        <FunctionInput label="End index"
                                       value={funcTypeOptions["endIndexValue"]}
                                       onChange={(e) => this.onPropertyValueChange(e, "endIndex", funcTypeOptionsField)}
                        />
                    </>
                }

                {funcType === "itemPropertyToContext" &&
                    <React.Fragment>
                        <div className="predicate-box left">
                            <ValueTypeSelector
                                types={this.propertyTypes}
                                disableArea={this.props.disableArea}
                                selectedType={funcTypeOptions["dataType"]}
                                onTypeSelect={(index) => this.onItemPropertyTypeChange(index, "data", funcTypeOptionsField)}
                            />

                            {(() => {
                                switch (funcTypeOptions["dataType"]) {
                                    case "itemProperty":
                                        return (<PropertySelect
                                            value={funcTypeOptions["dataValue"]}
                                            onChange={(e) => this.onPropertyValueChange(e, "data", funcTypeOptionsField)}
                                            options={this.props.itemProperties}
                                        />);
                                    case "dynamicProperty":
                                        return (<input
                                            type="text"
                                            value={funcTypeOptions["dataValue"]}
                                            onChange={(e) => this.onPropertyValueChange(e, "data", funcTypeOptionsField)}
                                        />);
                                }
                            })()}
                        </div>
                    </React.Fragment>
                }

                <div className="fm_delete" onClick={() => this.props.onArgumentDelete()}>
                    <MaterialIcon icon="close"/>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="predicate-item">
                {this.createRow()}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        properties: state.properties
    }
}

export default connect(mapStateToProps, {showToastForFrontend, showToastForBackend})(ContextPropertyModifierValue);